import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRobot } from "@fortawesome/free-solid-svg-icons";

const AIFeedbackButton = ({ onClick, className, isLoading, label }) => {
  return (
    <button
      onClick={onClick}
      className={`feedback-control-button ${className}`}
      disabled={isLoading}
    >
      <FontAwesomeIcon icon={faRobot} className="ai-icon" spin={isLoading} />
      {isLoading ? "Loading..." : label}
    </button>
  );
};

export default AIFeedbackButton;
